import socketio from "socket.io-client";
import React from "react"
import {MediaRecorderWaveform} from "./WaveForm";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { ServerURL } from './ServerURL';
import { createMeeting, getRemainingTime, untilNow, delete_meeting, ping } from "./Network";
import { Navigate } from "react-router-dom";
import {Topbar} from "./Topbar.js"
import { addLineBreak } from "./addLineBreak.js";
import Alert from '@mui/material/Alert';
import { getSentence } from "./translations.js";
import { isMobile } from "react-device-detect";
import { tutoStartMeeting, tutoEndMeeting } from "./tutoStartMeeting.js";
import PauseBttn from "../imgs/pause_recording.png"
import MicBttn from "../imgs/start_recording.png"
import StopBttn from "../imgs/stop_recording.png"
import PlayBttn from "../imgs/play_button.png"
import MicBttnDissabled from "../imgs/start_recording_disabled.png"
import { Beforeunload } from 'react-beforeunload';
import NoSleep from '@uriopass/nosleep.js';
import { matomoEvent } from "./matomoTracker.js";
import Editor from "./Editor.js";

// free public stun servers(by google) ,but no turn server.
const iceservers = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },
    { urls: 'stun:stun2.l.google.com:19302' },
   { urls: 'stun:stun3.l.google.com:19302' }
    // { urls: 'stun:coturn.servepics.com:3478' },
  ],
}

var noSleep = new NoSleep();


export class Recorder extends React.Component {

  constructor()
  {
    super();

    this.socket = socketio(ServerURL, {
      autoConnect: true,
    });
    this.meetingId = undefined
    this.chunks = [];
    this.counter = 0;
    this.nbrCallToUntilNow = 0;
    this.chunksSize = 1000 * 29; //in milliseconds. Dictate the rate of upload.
    this.padding = 30;  //total pading size in px.

    this.socketListener()

    this.state = {
        WaveformDiv: tutoStartMeeting(),// EmptyWaveform(),
        ServerReturn: "",
        beforeUnloadEvent: "",
        topbar: <Topbar page={true} recording={false}/>, 
        controlButtons: ""
    }
  }

  componentDidMount()
  {
   this.createMicBttn(false)
  }

  createMicBttn(disabled)
  {
    var BttnPosition = {left: "50%",
    transform: "translate(-50%, 0%)",
    maxWidth: "10%",
    maxHeight: "10%",
    alignItems: "flex-end",
    position:"fixed",
    bottom:"0px",
    zIndex: "999"
  }

    if(isMobile){
      BttnPosition = {left: "50%",
      transform: "translate(-50%, 0%)",
      maxWidth: "30%",
      maxHeight: "30%",
      position:"fixed",
      bottom:"0px",
      zIndex: "999"
      }
    }

    var img = MicBttn
    if(disabled){
      img = MicBttnDissabled
    }

    this.setState({controlButtons: <IconButton
                        sx={BttnPosition} 
                        onClick={()=>{
                          if(this.meetingId === undefined)
                          {
                            //disable screen sleep if it's a mobile.
                            if(isMobile)
                            {
                              document.addEventListener('click', function enableNoSleep() {
                                document.removeEventListener('click', enableNoSleep, false);
                                noSleep.enable();
                              }, false);
                            }
                            //start the recording.
                            this.joinMeeting()
                          }
                        }}>
                      <img src={img} alt="microphone button" width="100%"/>
                  </IconButton>}
                )
  }

  createPausePlayAndStopBttn(play)
  {
    var BttnPosition = {
    maxWidth: "10%",
    maxHeight: "10%",
    pointerEvents: "auto"
    }

    if(isMobile){
      BttnPosition = {
      maxWidth: "30%",
      maxHeight: "30%",
      pointerEvents: "auto"
      }
    }

    var bttn2 = <IconButton 
                  sx={BttnPosition}
                  onClick={()=>{
                    this.createPausePlayAndStopBttn(false)
                    this.pauseRecord()}}
                >
                  <img src={PauseBttn} alt="microphone button" width="100%"/>
                </IconButton>

    if(!play) //if in pause we display the "play" button instead of the "pause" one.
    {
      bttn2 = <IconButton 
          sx={BttnPosition}
          onClick={()=>{
            this.resumeRecord()
            this.createPausePlayAndStopBttn(true)}}
        >
          <img src={PlayBttn} alt="microphone button" width="100%"/>
        </IconButton>
    }

    this.setState({controlButtons: <Stack direction={"row"} justifyContent="center" spacing={2} 
                                          sx={{position:"fixed", bottom:"0px", pointerEvents: "none", zIndex: "999"}}>
                        <IconButton
                          sx={BttnPosition}
                          onClick={()=>{
                            this.leaveMeeting()
                          }}
                        >
                         <img src={StopBttn} alt="microphone button" width="100%"/>
                      </IconButton>

                      {bttn2}
                      
                    </Stack>
                    })
  }


  socketListener()
  {
    this.socket.on('start_call', async () => {
      // creat new peerconnect ,and use ice server information(stun or turn server)
      var rtcpeerconnection = new RTCPeerConnection(iceservers)
      this.startRecord()

      this.createOffer(rtcpeerconnection)
    })

    this.socket.on('transfer_complete', async () => { 
      //ensure that the transcription will only be asked once the audio has been fully uploaded.
      await this.socket.emit('leave', [this.meetingId]);

      this.meetingId = undefined;
      this.createMicBttn(false)  //update the mic state.
    })
  }


  createOffer(rtcpeerconnection) {
    let sessionDescription
    try {
      sessionDescription = rtcpeerconnection.createOffer()
      rtcpeerconnection.setLocalDescription(sessionDescription)
    } catch (error) {
      console.error(error)
    }
  }


  //get autorizations and create a stream object with voice frequency filtering.
  async getRecordingAutorization()
  {
    try {
      // Get the raw audio stream
      const rawStream = await navigator.mediaDevices.getUserMedia({audio: true,video: false})
      
      // Apply voice frequency filtering
      this.stream = await this.applyVoiceFrequencyFilter(rawStream);
      
      return true;
    } catch (error) {
      //if the authorization isn't obtained.
      alert(getSentence(41))
      await this.leaveMeeting()
      delete_meeting(this.meetingId)
      this.createMicBttn(false)
      return false;
    }
  }

  // Apply bandpass filter to isolate human voice frequencies
  async applyVoiceFrequencyFilter(inputStream) {
    try {
      // Create audio context
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // Create source from input stream
      const source = this.audioContext.createMediaStreamSource(inputStream);
      
      // Create destination stream
      const destination = this.audioContext.createMediaStreamDestination();
      
      // Voice frequency filtering chain
      const { processedSource } = this.createVoiceFilterChain(source);
      
      // Connect to destination
      processedSource.connect(destination);
      
      // Store references for cleanup
      this.originalStream = inputStream;
      this.filteredDestination = destination;
      
      return destination.stream;
    } catch (error) {
      console.warn('Voice filtering not supported, using original stream:', error);
      return inputStream;
    }
  }

  // Create comprehensive voice filtering chain
  createVoiceFilterChain(source) {
    // 1. High-pass filter: Remove low-frequency noise (below 80Hz)
    const highPassFilter = this.audioContext.createBiquadFilter();
    highPassFilter.type = 'highpass';
    highPassFilter.frequency.setValueAtTime(80, this.audioContext.currentTime); // Remove rumble, AC hum
    highPassFilter.Q.setValueAtTime(0.7, this.audioContext.currentTime);

    // 2. Low-pass filter: Remove high-frequency noise (above 8kHz) 
    const lowPassFilter = this.audioContext.createBiquadFilter();
    lowPassFilter.type = 'lowpass';
    lowPassFilter.frequency.setValueAtTime(8000, this.audioContext.currentTime); // Keep speech intelligibility
    lowPassFilter.Q.setValueAtTime(0.7, this.audioContext.currentTime);

    // 3. Parametric EQ: Boost fundamental voice frequencies (300-3400Hz)
    const voiceBoost = this.audioContext.createBiquadFilter();
    voiceBoost.type = 'peaking';
    voiceBoost.frequency.setValueAtTime(1000, this.audioContext.currentTime); // Center of speech
    voiceBoost.Q.setValueAtTime(2, this.audioContext.currentTime); // Moderate bandwidth
    voiceBoost.gain.setValueAtTime(3, this.audioContext.currentTime); // +3dB boost

    // 4. Notch filter: Remove 50/60Hz electrical interference
    const notchFilter = this.audioContext.createBiquadFilter();
    notchFilter.type = 'notch';
    notchFilter.frequency.setValueAtTime(60, this.audioContext.currentTime); // 60Hz (US) or 50Hz (Europe)
    notchFilter.Q.setValueAtTime(10, this.audioContext.currentTime); // Narrow notch

    // 5. Dynamic range compressor: Even out voice levels
    const compressor = this.audioContext.createDynamicsCompressor();
    compressor.threshold.setValueAtTime(-24, this.audioContext.currentTime); // dB
    compressor.knee.setValueAtTime(30, this.audioContext.currentTime);
    compressor.ratio.setValueAtTime(6, this.audioContext.currentTime); // 6:1 compression
    compressor.attack.setValueAtTime(0.003, this.audioContext.currentTime); // 3ms
    compressor.release.setValueAtTime(0.25, this.audioContext.currentTime); // 250ms

    // 6. Gain node: Final level adjustment
    const gainNode = this.audioContext.createGain();
    gainNode.gain.setValueAtTime(1.2, this.audioContext.currentTime); // +20% boost

    // Connect the filtering chain
    source
      .connect(highPassFilter)      // Remove low-frequency noise
      .connect(notchFilter)         // Remove electrical interference  
      .connect(voiceBoost)          // Boost voice frequencies
      .connect(lowPassFilter)       // Remove high-frequency noise
      .connect(compressor)          // Smooth dynamic range
      .connect(gainNode);           // Final level adjustment

    // Store filter references for dynamic adjustment
    this.voiceFilters = {
      highPass: highPassFilter,
      lowPass: lowPassFilter,
      voiceBoost: voiceBoost,
      notch: notchFilter,
      compressor: compressor,
      gain: gainNode
    };

    return { processedSource: gainNode };
  }

  // Cleanup audio context and streams
  cleanupAudioFiltering() {
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }
    if (this.originalStream) {
      this.originalStream.getTracks().forEach(track => track.stop());
    }
  }

  startToElapseTime()
  {
    this.ElapseTime = setInterval(() => {
      var seconds = (Date.now() - this.StartingTime) / 1000 ;
      const hours = Math.trunc(seconds / 3600)
      seconds = seconds - (hours * 3600)
      const minutes = Math.trunc(seconds / 60)
      seconds = Math.trunc(seconds - (minutes * 60))
      const text = getSentence(63) + " : " + String(hours) + "h, " + String(minutes) + "m, " + String(seconds) + "s"
      this.setState({ ElapsedTime: <p style={{textAlign: "center"}}>{text}</p>});
    }, 1*1000);  // 1 second
  }


  // record audio and upload it.
  async startRecord()
  {
    //In case this is not the first meeting recorder instance,
    // we delete the message previously returned by the server (usually the "so far").
    this.setState({ ServerReturn: getSentence(75)});

    var mimeType = 'audio/wav; codecs=opus';
  	this.mediarecorder = new MediaRecorder(this.stream, { type: mimeType });

  	this.mediarecorder.start(this.chunksSize);
    this.StartingTime = Date.now();
    this.pausesDuration = 0;
    this.startToElapseTime();

    this.setState({WaveformDiv: MediaRecorderWaveform(this.mediarecorder, this.padding)});
    this.createPausePlayAndStopBttn(true)

  	this.mediarecorder.ondataavailable = (event) => {
      this.chunks.push(event.data);

      this.socket.emit('upload_blob',[this.chunks.shift(), this.meetingId, 1])
  	};
  }


  async startPing()
  {
    //Regularly ping the server to confirm that the recording is still happening.
    //If the ping stop for too long the server will close the connexion and start to transcribe the meeting.
    this.Ping = setInterval(() => {
      ping(this.meetingId)
    }, 30*1000);  // 30 seconds
  }

  
  // stop recording and send the remaining data.
  async stopRecord()
  {
    if(this.mediarecorder != undefined)
    {
      this.mediarecorder.stop() 
      this.setState({ WaveformDiv: tutoEndMeeting()});

      var atlast = this.chunks.length

      if(atlast != 0){
        for (let i = 0; i < atlast; i++) {
          await this.socket.emit('upload_blob',[this.chunks[i],this.meetingId, 1])
        }
      }
      await this.socket.emit('upload_blob',[[0],this.meetingId, 0])
    }

    clearInterval(this.Ping);
    clearInterval(this.ElapseTime);
    this.setState({ ElapsedTime: ""});

    if(this.state.ServerReturn === getSentence(75))
    { /* if the UntilNow never was obtained from the server we remove the indication that it will be here */
      this.setState({ ServerReturn: ""});
    }

  }


  async pauseRecord()
  {
    if(this.mediarecorder != undefined)
    {
      this.mediarecorder.pause()
      clearInterval(this.ElapseTime);
      this.startPauseAt = Date.now();

      var atlast = this.chunks.length

      if(atlast != 0){
        for (let i = 0; i < atlast; i++) {
          await this.socket.emit('upload_blob',[this.chunks[i],this.meetingId, 1])
        }
      }
    }
  }


  resumeRecord()
  {
    if(this.mediarecorder != undefined)
    {
      this.mediarecorder.resume()
      const pauseDuration = Date.now() - this.startPauseAt;
      this.StartingTime = this.StartingTime + pauseDuration;
      this.startToElapseTime();
      this.setState({WaveformDiv:""}, ()=>{   //The waveform don't update anymore without this hack.
        this.setState({WaveformDiv: MediaRecorderWaveform(this.mediarecorder, this.padding)});
      })
    }
  }



  // join a meeting. Called immediatelly when the user click on the button to start a meeting.
  async joinMeeting()
  {
    this.meetingId = -1;  // to avoid a double ckick on the new meeting button

    //help the user to not close/quit the page while recording.
    this.setState({beforeUnloadEvent: <Beforeunload onBeforeunload={() => 'This will stop the record'} />,
                  topbar: <Topbar page={true} recording={true}/>})


    this.meetingId = await parseInt(await createMeeting());

    if (this.meetingId === -1)  //the user don't have time left in their subscription.
    {
      //release the recording state.
      this.setState({beforeUnloadEvent: "", topbar: <Topbar page={true} recording={false}/>})

      const errormsg = addLineBreak(getSentence(47))
      const toprint = <Alert severity="error">{errormsg}</Alert>

      this.setState({ ServerReturn:toprint});
      this.meetingId = undefined;
      matomoEvent("abort meeting", "web", "not enough credits")
      return null;
    }
    else
    {
      //get autorization then create meeting
      var tmp = await this.getRecordingAutorization()
      if(tmp)
      {
        // start connect
        this.socket.emit('start_call', [this.meetingId])
      }
      else
      {
        return
      }

      this.untilNow = setInterval(() => {
        this.displayServerReturn();
        this.counter = this.counter + 1;
      }, 5*60*1000);  // 5min
  

      this.remainingTime = setInterval(async() => {
        var remainingTime = await getRemainingTime();
        remainingTime = remainingTime[0] + remainingTime[1]
          
        if (remainingTime <= 600 && remainingTime > 0)
          {
            const toprint = <Alert severity="warning">{getSentence(62)}</Alert>
            this.setState({ ServerReturn:toprint});
          }
        if (remainingTime < 70 && remainingTime >= 0)
          {
            this.displayServerReturn();
          }
        if (remainingTime <= 0)
        {
          const toprint = <Alert severity="error">{getSentence(61)}</Alert>
          this.setState({ ServerReturn:toprint});
        }
      }, 60*1000);
      matomoEvent("start meeting", "web", "")
    }

    //If mobile, lock the screen to avoid unloading "unused tab"
    if (isMobile)
    {
      try {
        this.wakeLock = await navigator.wakeLock.request("screen");

        //reacquires the wake lock should the visibility of the document change and the wake lock is released.
        document.addEventListener("visibilitychange", async () => {
          if (this.wakeLock !== null && document.visibilityState === "visible") {
            this.wakeLock = await navigator.wakeLock.request("screen");
          }
        });
      } catch (err) {} 
    }

  }

  // leave a meeting
  async leaveMeeting()
  {
    await this.stopRecord();

    // Cleanup audio filtering resources
    this.cleanupAudioFiltering();

    this.createMicBttn(true)
    clearInterval(this.untilNow);
    clearInterval(this.remainingTime);

    this.setState({beforeUnloadEvent: "", topbar: <Topbar page={true} recording={false}/>})
    noSleep.disable();
    //If mobile, unlock the screen
    if (isMobile)
    {
      this.wakeLock.release().then(() => {
        this.wakeLock = null;
      });
    }

    matomoEvent("leave meeting", "web", "")
}


  async displayServerReturn()
  {
    //fetch and update the "until now" server's response.
    //only do it if the recording isn't stopped and if the interval since the last fetching is old enough.
    if (this.mediarecorder.state === "recording" || this.mediarecorder.state === "paused")
    {
      clearInterval(this.untilNow);
      const data = await untilNow(this.meetingId)

      this.nbrCallToUntilNow = this.nbrCallToUntilNow + 1

      var interval = 5  // in minutes
      if(this.nbrCallToUntilNow >= 15) //4h of recording
      {
        interval = 120
      }
      else if(this.nbrCallToUntilNow >= 14) //3h of recording
      {
        interval = 60
      }
      else if(this.nbrCallToUntilNow >= 11) //1h30 of recording
      {
        interval = 30
      }
      else if(this.nbrCallToUntilNow >= 9)  //1h of recording
      {
        interval = 15
      }
      else if(this.nbrCallToUntilNow >= 6)  //30min of recording
      {
        interval = 10
      }

     
      this.untilNow = setInterval(() => {
        this.displayServerReturn();
      }, interval*60*1000);

      if(data.txt === ""){  //then there is probably an error on the server side.
        return
      }

      const updateDoNothing = async (value) => {};

      const toprint = <div id="demo" style={{ width: isMobile ? '100%':"90%", margin: "auto" }}>
        <Box
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === 'dark' ? '#101010' : 'grey.100',
            color: (theme) =>
              theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
            border: '1px solid',
            borderColor: (theme) =>
              theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
            p: 1,
            borderRadius: 2,
            fontSize: '0.875rem',
            fontWeight: '700',
            textAlign: "left",
            overflowY: 'auto'
          }}
          key={this.nbrCallToUntilNow}
        >
          {
            Editor(
              data.txt,
              updateDoNothing,
              false,
              false,
              false,
              true,
            )
          }
        </Box>
      </div>

      this.setState({ ServerReturn:toprint});
      matomoEvent("update until now", "web", "call number " + this.nbrCallToUntilNow)
    }
  }

  getBackToMainPage()
  {
    this.setState({ ServerReturn: <Navigate to="/" replace={false} />});
  }

  componentWillUnmount() 
  {
    // If recording we try to send the last chuncks of datas and to launch the transcription.
    if(this.meetingId !== undefined){
      this.leaveMeeting();
    }

    // Cleanup audio filtering resources (additional safety)
    this.cleanupAudioFiltering();

    // Clean up socket event listeners
    if (this.socket) {
      this.socket.off('start_call');
      this.socket.off('transfer_complete');
      this.socket.disconnect();
    }
  }




  render()
  {
    return (
      <Box>
        {this.state.topbar}

        <Box
        sx={{
          width: '100%',
          height: '100%',
          '& > .MuiBox-root > .MuiBox-root': {
            p: 1,
            borderRadius: 2,
            fontSize: '0.875rem',
            fontWeight: '700',
          },
          paddingLeft: this.padding/2 + "px",
          paddingRight: this.padding/2 + "px",
          boxSizing: "border-box"
        }}
      >


        <Toolbar />

          {this.state.ElapsedTime}
          {this.state.WaveformDiv }

          {this.state.controlButtons}
          <p style={{textAlign: "center"}}>
            {this.state.ServerReturn}
          </p>
          {this.state.beforeUnloadEvent}

          <div style={{minHeight:window.innerHeight*0.15}}><span></span></div>  
        
        <Toolbar />
      </Box>
    </Box>

    );
  }
}
